import { render, staticRenderFns } from "./NewPassword.vue?vue&type=template&id=5d223518&scoped=true&lang=pug&"
import script from "./NewPassword.vue?vue&type=script&lang=ts&"
export * from "./NewPassword.vue?vue&type=script&lang=ts&"
import style0 from "./NewPassword.vue?vue&type=style&index=0&id=5d223518&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d223518",
  null
  
)

export default component.exports